import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Observable, of, timer } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '@app/services/user-roles.service';

const routeMap: any = {
  'forecast-lab:user': '/',
  'future-order:user': '/future-order',
};

@Injectable({
  providedIn: 'root',
})
export class RbacGuard implements CanActivate {
  constructor(
    private msalService: MsalService,
    private userService: UserService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Check if a user is authenticated
    // if (this.msalService.instance.getAllAccounts().length === 0) {
    //   // Not logged in, redirect to login page
    //   return this.router.createUrlTree(['/login']);
    // }

    const requiredRoles = route.data['roles'] as string[];
    const routeName = route.url.map((segment) => segment.path)[0];
    if (!requiredRoles || requiredRoles.length === 0) {
      if (routeName === 'raise-access-request' && !this.userService.getConaId()) {
        return of(this.router.createUrlTree(['/']));
      }
      // No roles required for this route, allow access.
      return true;
    }

    return this.userService.getRoles().pipe(
      map((roles: any) => {
        const hasRequiredRole = this.userService.hasAnyRole(requiredRoles);

        if (hasRequiredRole) {
          return true;
        } else {
          if (roles.length) {
            return this.router.createUrlTree([routeMap[roles[0]]]);
          } else {
            if (this.userService.getConaId()) {
              return this.router.createUrlTree(['/future-order']);
            }
            throw {};
            // User does not have the required role, redirect to an unauthorized page or home
          }
        }
      }),
      catchError((err) => {
        // On error, redirect to a safe route
        return timer(2000).pipe(map(() => this.router.createUrlTree(['/'])));
      })
    );
  }
}
